import { useCallback, useMemo, useState } from 'react'
import { useParams } from 'react-router-dom'
import {
  ValidateFormData, ValidateResult, PostValidate,
  RegisterFormData, PostRegister, RegisterResult
} from 'interface/user/register'

export const useUserRegisterContainer = () => {
  const { domain, inviteId } = useParams()
  const params = useMemo(
    () => ({
      domain: String(domain),
      inviteId: String(inviteId),
    }),
    [domain, inviteId]
  )
  const [isPosting, setIsPosting] = useState<boolean>(false)
  const [errorMessage, setErrorMessage] = useState<string | null>(null)
  const [step, setStep] = useState<'validate' | 'register' | 'agreement' | 'finished'>('validate')
  const [validateResult, setValidateResult] = useState<ValidateResult | null>(null)
  const [registeredResult, setRegisteredResult] = useState<RegisterResult | null>(null)

  const onValidate = useCallback(
    async (form: ValidateFormData) => {
      setIsPosting(true)
      setErrorMessage(null)
      try {
        const response = await PostValidate(params.domain, params.inviteId, form)
        setValidateResult(response)
        setStep('register')
      } catch (e) {
        console.error('failed to validte', e)
        setErrorMessage('招待コードの認証に失敗しました')
      } finally {
        setIsPosting(false)
      }
    },
    [params, setErrorMessage, setValidateResult, setStep]
  )
  const onRegister = useCallback(
    async (form: RegisterFormData) => {
      setIsPosting(true)
      setErrorMessage(null)
      try {
        const result = await PostRegister(params.domain, form)
        setRegisteredResult(result)
        setStep('finished')
      } catch (e) {
        console.error('failed to regist user', e)
        setErrorMessage('ユーザーの登録に失敗しました')
      } finally {
        setIsPosting(false)
      }
    },
    [setErrorMessage, setStep, params.domain]
  )
  return useMemo(
    () => ({
      domain: params.domain,
      inviteId: params.inviteId,
      isPosting,
      errorMessage,
      step,
      onValidate, validateResult,
      onRegister, registeredResult
    }),
    [
      params,
      isPosting,
      errorMessage,
      step,
      onValidate, validateResult,      
      onRegister, registeredResult
    ]
  )
}
